import { useEffect } from "react";

/**
 * Injects a JSON-LD <script> tag into <head> for the lifetime of the component.
 * Pass a stable `id` so updates replace the existing tag instead of duplicating it.
 */
export function useJsonLd(id: string, data: Record<string, any> | null) {
  useEffect(() => {
    if (!data) return;
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    };
  }, [id, JSON.stringify(data)]);
}
